module.exports = __webpack_public_path__ + "static/media/search_dark_icon.545863c6.svg";